<template>
  <div class="image-gallery">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-if="videos && videos.length && videos[0]"
        v-for="(src, index) in videos"
        :key="`video-gallery-item-${index}`"
      >
        <div class="image news__video-wrap">
          <video :src="src" class="news__video" controls></video>
        </div>
      </swiper-slide>
      <swiper-slide v-if="gallery && gallery.length && gallery[0]"
        v-for="(src, index) in gallery"
        :key="`image-gallery-item-${index}`"
      >
        <div class="image" :style="{ backgroundImage: `url('${src}')` }"></div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
  export default {
    name: "news-slider",
    data: () => ({
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        speed: 500,
      },
    }),

    props: {
      gallery: {
        type: Array,
      },
      videos: {
        type: Array,
        default: [],
      },
    },
  };
</script>

<style lang="less">
  .news {
    &__video {
      position: absolute;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;

      &-wrap {
        background: rgba(0, 0, 0, 0.5) !important;
      }
    }

    .image-video {
    }
  }
</style>
